import React from "react";
import { Text } from "@sede-enterprise/shell-ds-react-framework";
import { BaseModal } from "./ConfirmationModal";

interface AccessDeniedModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Modal to display when user doesn't have permission to submit returns
 */
export const AccessDeniedModal: React.FC<AccessDeniedModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <BaseModal
      open={open}
      title="Access Denied"
      onClose={onClose}
      actions={[
        {
          label: "Close",
          action: onClose,
        },
      ]}
    >
      <div style={{ marginBottom: "20px" }}>
        <Text size="medium" style={{ color: "#dc3545" }}>
          You don't have permission to submit capacity returns.
        </Text>
        <br />
        <Text size="medium">
          Please contact the ITA Support team if you require this access.
        </Text>
      </div>
    </BaseModal>
  );
};